import { useState, useEffect } from "react";

import Box from "@mui/material/Box";

import useModule from "../../common/hooks/useModule";

function AbsoluteContentCard({
  id,
  type,
  onLoad,
  addItem = ({ row, column, id }) => {},
  chapterId,
  data,
  enrollmentId,
  position,
  size,
  placement,
  fullWidth,
  ...rest
}) {
  useEffect(() => {
    const handleContextmenu = (e) => {
      e.preventDefault();
    };
    if (data.confidential == "S") {
      document.addEventListener("contextmenu", handleContextmenu);
    }
    return function cleanup() {
      document.removeEventListener("contextmenu", handleContextmenu);
    };
  }, []);

  const [Component, { fetchModule }] = useModule({
    id,
    type: data?.contentType,
  });

  return (
    <Box
      sx={{ overflow: "auto" }}
      position={fullWidth ? "block" : "absolute"}
      margin={"10px auto"}
      {...size}
      {...position}
    >
      <Component
        quadrantData={data}
        quadrantId={data.chapterContentId}
        value={data.content || data.resource}
        mandatory={data.mandatory}
        options={{ removePlayerControl: data.removePlayerControl }}
        recursoId={data.resource}
        chapterId={chapterId}
        enrollmentId={enrollmentId}
        size={size}
      />
    </Box>
  );
}

export default AbsoluteContentCard;
